import { theme } from 'antd';

export const darkThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    // Primary colors
    colorPrimary: '#56802d',
    colorPrimaryHover: '#85A65B',
    colorPrimaryActive: '#4A7325',
    colorPrimaryBg: '#0E2404',
    colorPrimaryBgHover: '#1A3809',
    colorPrimaryBorder: '#375E19',
    colorPrimaryBorderHover: '#4A7325',
    colorPrimaryHoverBg: '#1A3809',
    colorPrimaryText: '#ffffff',
    colorPrimaryTextActive: '#ffffff',
    colorPrimaryTextHover: '#ffffff',

    // Background colors
    colorBgBase: '#141414',
    colorBgContainer: '#1f1f1f',
    colorBgElevated: '#262626',
    colorBgLayout: '#000000',
    colorBgSpotlight: '#262626',
    colorBgMask: 'rgba(0, 0, 0, 0.45)',

    // Text colors
    colorText: '#ffffff',
    colorTextBase: '#ffffff',
    colorTextSecondary: '#a6a6a6',
    colorTextTertiary: '#8c8c8c',
    colorTextQuaternary: '#595959',
    colorTextPlaceholder: '#595959',
    colorTextDisabled: '#595959',
    colorTextLabel: '#a6a6a6',
    colorTextDescription: '#8c8c8c',

    // Border colors
    colorBorder: '#303030',
    colorBorderSecondary: '#262626',
    colorBorderBg: '#1f1f1f',

    // Fill colors
    colorFill: '#303030',
    colorFillSecondary: '#262626',
    colorFillTertiary: '#1f1f1f',
    colorFillQuaternary: '#141414',

    // Success colors
    colorSuccess: '#52c41a',
    colorSuccessHover: '#73d13d',
    colorSuccessActive: '#389e0d',
    colorSuccessBg: '#162312',
    colorSuccessBgHover: '#1f371b',
    colorSuccessBorder: '#49aa19',
    colorSuccessBorderHover: '#73d13d',

    // Warning colors
    colorWarning: '#faad14',
    colorWarningHover: '#ffc53d',
    colorWarningActive: '#d48806',
    colorWarningBg: '#2b1d05',
    colorWarningBgHover: '#3d2b0a',
    colorWarningBorder: '#d89614',
    colorWarningBorderHover: '#ffc53d',

    // Error colors
    colorError: '#ff4d4f',
    colorErrorHover: '#ff7875',
    colorErrorActive: '#d9363e',
    colorErrorBg: '#2a1215',
    colorErrorBgHover: '#3d1d1f',
    colorErrorBorder: '#a61d24',
    colorErrorBorderHover: '#ff7875',

    // Info colors
    colorInfo: '#1890ff',
    colorInfoHover: '#40a9ff',
    colorInfoActive: '#096dd9',
    colorInfoBg: '#111b26',
    colorInfoBgHover: '#112a45',
    colorInfoBorder: '#177dd3',
    colorInfoBorderHover: '#40a9ff',

    // Custom colors for your app
    colorPrimary1: '#4A7325',
    colorPrimaryLight: 'rgba(255, 255, 255, 0.07)',
    colorFillContent: '#262626',
    colorSelectedTab: '#56802d',
    borderRadiusLG: 10,
    buttonColor: '#56802d',
    boxShadowNone: 'none',
    buttonBackgroundColor: '#56802d',

    // Market colors
    marketWatchDown: '#ff4d4f',
    marketWatchUp: '#52c41a',
    tradeModalBuyColor: '#52c41a',

    // Font
    fontFamily: 'Poppins, sans-serif',
  },
  components: {
    Radio: {
      colorPrimary: '#56802d',
    },
    Checkbox: {
      colorPrimary: '#56802d',
      colorPrimaryHover: '#85A65B',
      colorBgLightGrey: '#262626',
    },
    Card: {
      colorBgContainer: '#1f1f1f',
      colorBorderSecondary: '#303030',
    },
    Table: {
      colorBgContainer: '#1f1f1f',
      colorFillAlter: '#262626',
      colorBorderSecondary: '#303030',
    },
    Modal: {
      colorBgElevated: '#1f1f1f',
      colorBgMask: 'rgba(0, 0, 0, 0.65)',
    },
    Drawer: {
      colorBgElevated: '#1f1f1f',
    },
    Menu: {
      colorItemBg: '#1f1f1f',
      colorSubItemBg: '#262626',
      colorItemBgSelected: 'rgba(63, 78, 79, 0.45)',
      colorItemBgHover: 'rgba(63, 78, 79, 0.25)',
    },
    Layout: {
      colorBgHeader: '#141414',
      colorBgSider: '#141414',
      colorBgTrigger: '#1f1f1f',
    },
    Input: {
      colorBgContainer: '#262626',
      colorBorder: '#303030',
      colorTextPlaceholder: '#595959',
    },
    Select: {
      colorBgContainer: '#262626',
      colorBorder: '#303030',
    },
    Button: {
      colorBgContainer: '#262626',
      colorBorder: '#303030',
    },
    Tooltip: {
      colorBgSpotlight: '#1E293B',
      colorTextLightSolid: '#ffffff',
    },
  },
}; 